import AppContext from 'App/AppContext';
import Accordion from 'components/Accordion/Accordion';
import TenantPicker, { PickerTenant, TenantPickerMode } from 'components/Pickers/TenantPicker';
import { globalStackTokensGapMedium } from 'globalStyles';
import ProcessingActivity from 'models/processingActivity';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LocalStorageKeys, getLocalStorageData, setLocalStorageData } from 'utils/localstorage';
import { IPStack } from 'baseComponents/Stack/IPStack';

export interface IProcessingResponsibleEntitiesProps {
  selectedProcessingActivity?: ProcessingActivity;
  setResponsibleTenants: (tenantIds: string[]) => void;
}

export const ProcessingResponsibleEntities = (props: IProcessingResponsibleEntitiesProps) => {
  const appContext = useContext(AppContext);
  const { t } = useTranslation(['translation', 'processingActivity']);
  const [allTenants, setAllTenants] = useState<PickerTenant[]>([]);
  const [selectedTenantIds, setSelectedTenantIds] = useState<string[]>(
    props.selectedProcessingActivity?.responsibleEntitiesTenants ?? [],
  );
  const selectedTenants = allTenants.filter((t) => selectedTenantIds.includes(t.tenantId) ?? false);

  const onSelectTenants = (items: PickerTenant[]) => {
    const tenantIds = items.map((i) => i.tenantId);
    setSelectedTenantIds(tenantIds);
    props.setResponsibleTenants(tenantIds);
  };

  const getSummary = (): string => {
    let result = '';
    for (let i = 0; i < selectedTenants.length; i++) {
      const tenant = selectedTenants[i];
      if (i > 0 && i < selectedTenants.length) {
        result += ', ';
      }
      result += tenant.name;
    }

    return result;
  };

  const getDefaultActiveFromLocalState = (): boolean => {
    const localState = getLocalStorageData(appContext, LocalStorageKeys.ProcessingResponsibleEntitiesAccordion);

    return localState === 'true';
  };

  const setDefaultActiveToLocalState = (expanded: boolean) => {
    setLocalStorageData(appContext, LocalStorageKeys.ProcessingResponsibleEntitiesAccordion, expanded.toString());
  };

  //
  // Main render
  //
  return (
    <Accordion
      title={t('processingActivity:TabDetails.ResponsibleEntities')}
      info={t('processingActivity:TabDetails.ResponsibleEntitiesInfo')}
      showBorder={true}
      summary={getSummary()}
      defaultActive={getDefaultActiveFromLocalState()}
      onToggle={(expanded) => setDefaultActiveToLocalState(expanded)}
    >
      <IPStack verticalFill tokens={globalStackTokensGapMedium} styles={{ root: { padding: '10px' } }}>
        <IPStack.Item>
          <TenantPicker
            mode={TenantPickerMode.User}
            onSelect={onSelectTenants}
            selectedTenants={selectedTenantIds}
            summary={getSummary()}
            setAllTenants={setAllTenants}
            label={t('processingActivity:TabDetails.ResponsibleEntitiesTenantPickerLabel')}
          />
        </IPStack.Item>
      </IPStack>
    </Accordion>
  );
}